/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { useMemo, useCallback } from 'react';
import clsx from 'clsx';
import { DependentMemberInCell, MemberInCell, MemberStatus } from '../../@types/Members';
import { Table } from '../Table';
import { getMemberStatus, getMemberStatusLabel, getMemberStatusTextClass } from '../../flows/Members/utils';
import { useAuth } from '../../context/AuthContext';
import moment from 'moment';
import { Nullable } from '@td-client-frontend/internal/src/@types/common';
import WithPermission from '../WithPermission';
import { Permissions } from '../../@types/Permissions';
import { useMemberContext } from '../../context/MemberContext';

const DATE_FORMAT = 'MM/DD/YYYY';

export const DependentTable = ({ data, onChoose }) => {
  const { checkPerm } = useAuth();
  const { isViewMode } = useMemberContext();
  const getDependentMemberActions = useCallback(
    ({ readOnly, mrnId }) => {
      return (
        <button className="flex items-center btn btn-link" type="button" onClick={() => onChoose(mrnId)}>
          {readOnly || isViewMode ? 'View' : 'Manage'}
        </button>
      );
    },
    [onChoose, isViewMode]
  );

  const dependentColumns = useMemo(() => {
    const columns = [
      {
        Header: 'First name',
        accessor: 'firstNm',
        sortable: true
      },
      {
        Header: 'Last name',
        accessor: 'lastNm'
      },
      {
        Header: 'Status',
        Cell: ({ row }: DependentMemberInCell) => {
          const { effectiveEndDt, effectiveStartDt } = row.original;

          const status: Nullable<MemberStatus> = getMemberStatus(effectiveStartDt, effectiveEndDt);

          return (
            status && (
              <span className={clsx(getMemberStatusTextClass(status), 'capitalize')}>
                {getMemberStatusLabel(status)}
              </span>
            )
          );
        }
      },
      {
        Header: 'Create date',
        Cell: ({ row }: DependentMemberInCell) =>
          row.original.createdAt ? moment(row.original.createdAt).format(DATE_FORMAT) : '-'
      },
      {
        Header: 'Effective date',
        Cell: ({ row }: DependentMemberInCell) =>
          row.original.effectiveStartDt ? moment(row.original.effectiveStartDt).format(DATE_FORMAT) : '-'
      },
      {
        Header: 'Term date',
        Cell: ({ row }: DependentMemberInCell) =>
          row.original.effectiveEndDt ? moment(row.original.effectiveEndDt).format(DATE_FORMAT) : '-'
      },
      {
        Header: 'DOB',
        Cell: ({ row }: DependentMemberInCell) => moment(row.original.dob).format(DATE_FORMAT)
      }
    ];

    if (checkPerm(Permissions.MemberRead) || checkPerm(Permissions.MemberWrite)) {
      columns.push({
        Header: 'Actions',
        Cell: ({ row: { original: memberInfo } }: MemberInCell) => {
          return (
            <WithPermission requiredPerms={[Permissions.MemberRead]}>
              {getDependentMemberActions(memberInfo)}
            </WithPermission>
          );
        }
      });
    }

    return columns;
  }, [checkPerm, getDependentMemberActions]);

  return (
    <>{data.length ? <Table columns={dependentColumns} data={data} /> : <p>Currently there are no dependents</p>}</>
  );
};
